import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import { CustomRadioGroupInput } from "../components/custom_radio_group_input";
import { DefaultTableDatePickerInput } from "../../../../../../common/components/default_table_date_picker_input";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import ButtonOcorrencia from "../components/button_ocorrencia";

/**
 * GenerateInspecaoPatrimonioItensColumnsDefinition
 */

type Props = {
  onActionOcorrencia: (idOcorrencia: number | null, idInspecaoPatrimonioItens: number | null, openState: boolean) => void;
  onActionInspecao1Change: (idInspecaoPatrimonioItens: number, value: string | number | null) => void;
  onActionDataInspecao1Change: (idInspecaoPatrimonioItens: number, value: Date | null) => void;
  onActionInspecao2Change: (idInspecaoPatrimonioItens: number, value: string | number | null) => void;
  onActionDataInspecao2Change: (idInspecaoPatrimonioItens: number, value: Date | null) => void;
  onActionLimpar: (idInspecaoPatrimonioItens: number) => void;
};

export const GenerateInspecaoPatrimonioItensColumnsDefinition = ({
  onActionOcorrencia,
  onActionInspecao1Change,
  onActionDataInspecao1Change,
  onActionInspecao2Change,
  onActionDataInspecao2Change,
  onActionLimpar,
}: Props): GridColDef[] => {
  const inspecao1Options = [
    {
      id: "N",
      label: "NA",
      style: {
        backgroundColor: "#89c4f4",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
    {
      id: "A",
      label: "A",
      style: {
        backgroundColor: "#45b6af",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
    {
      id: "R",
      label: "R",
      style: {
        backgroundColor: "#f8cb00",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
    {
      id: "X",
      label: "X",
      style: {
        backgroundColor: "#f3565d",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
  ];

  const inspecao2Options = [
    {
      id: "A",
      label: "RA",
      style: {
        backgroundColor: "#45b6af",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
    {
      id: "X",
      label: "X",
      style: {
        backgroundColor: "#f3565d",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
  ];

  return [
    {
      field: "descricao",
      filterable: false,
      headerName: "Item",
      flex: 1,
      minWidth: 120,
      sortable: false,
      renderCell: ({ value }) => <div className="w-full h-full py-2 flex items-center">{value}</div>,
    },
    {
      field: "novaOcorrencia",
      filterable: false,
      headerName: "",
      minWidth: 80,
      width: 80,
      sortable: false,
      headerClassName: "funcionarios-header",
      valueGetter: (_, row) => row["idInspecaoPatrimonioItens"] as number,
      renderCell: ({ value }) => {
        return (
          <div className="h-full flex justify-center items-center">
            <ButtonOcorrencia
              buttonColor="red"
              onClick={() => onActionOcorrencia(null, value, true)}
              startIcon={<DynamicIcon nameIcon="Add" size={10} className="text-white" />}>
              NC
            </ButtonOcorrencia>
          </div>
        );
      },
    },
    {
      field: "inspecao1",
      filterable: false,
      headerName: "1ª Inspeção",
      minWidth: 220,
      width: 220,
      sortable: false,
      valueGetter: (_, row) => ({ idInspecaoPatrimonioItens: row["idInspecaoPatrimonioItens"], inspecao1: row["inspecao1"] }),
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center">
            <CustomRadioGroupInput
              name="inspecao1"
              options={inspecao1Options}
              value={value.inspecao1}
              onValueChange={(v) => onActionInspecao1Change(value.idInspecaoPatrimonioItens, v)}
            />
          </div>
        );
      },
    },
    {
      field: "dataInspecao1",
      filterable: false,
      headerName: "Data",
      minWidth: 125,
      width: 125,
      sortable: false,
      valueGetter: (_, row) => ({ idInspecaoPatrimonioItens: row["idInspecaoPatrimonioItens"], dataInspecao1: row["dataInspecao1"] }),
      renderCell: ({ value }) => {
        return (
          <div className="w-[6.5rem] h-full flex items-center justify-center">
            <DefaultTableDatePickerInput
              sx={{
                '&.MuiFormControl-root.MuiPickersTextField-root': {
                  '.MuiPickersInputBase-root.MuiPickersOutlinedInput-root': {
                    '.MuiPickersSectionList-root.MuiPickersInputBase-sectionsContainer': {
                      fontSize: '0.75rem'
                    },
                    paddingLeft: '0.60rem',
                    paddingRight: '0.60rem',
                  },
                },
              }}
              value={value.dataInspecao1}
              onChange={(e) => onActionDataInspecao1Change(value.idInspecaoPatrimonioItens, e)}
            />
          </div>
        );
      },
    },
    {
      field: "inspecao2",
      filterable: false,
      headerName: "2ª Inspeção",
      minWidth: 125,
      width: 125,
      sortable: false,
      valueGetter: (_, row) => ({
        idInspecaoPatrimonioItens: row["idInspecaoPatrimonioItens"],
        inspecao1: row["inspecao1"],
        inspecao2: row["inspecao2"],
      }),
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center">
            <CustomRadioGroupInput
              name="inspecao2"
              options={inspecao2Options}
              disabled={value.inspecao1 !== "R"}
              value={value.inspecao2}
              onValueChange={(v) => onActionInspecao2Change(value.idInspecaoPatrimonioItens, v)}
            />
          </div>
        );
      },
    },
    {
      field: "dataInspecao2",
      filterable: false,
      headerName: "Data",
      minWidth: 125,
      width: 125,
      sortable: false,
      valueGetter: (_, row) => ({
        idInspecaoPatrimonioItens: row["idInspecaoPatrimonioItens"],
        inspecao1: row["inspecao1"],
        dataInspecao2: row["dataInspecao2"],
      }),
      renderCell: ({ value }) => {
        return (
          <div className="w-[6.5rem] h-full flex items-center justify-center">
            <DefaultTableDatePickerInput
              sx={{
                '&.MuiFormControl-root.MuiPickersTextField-root': {
                  '.MuiPickersInputBase-root.MuiPickersOutlinedInput-root': {
                    '.MuiPickersSectionList-root.MuiPickersInputBase-sectionsContainer': {
                      fontSize: '0.75rem'
                    },
                    paddingLeft: '0.60rem',
                    paddingRight: '0.60rem',
                  },
                },
              }}
              disabled={value.inspecao1 !== "R"}
              value={value.dataInspecao2}
              onChange={(e) => onActionDataInspecao2Change(value.idInspecaoPatrimonioItens, e)}
            />
          </div>
        );
      },
    },
    {
      field: "limpar",
      sortable: false,
      filterable: false,
      headerName: "Limpar",
      width: 65,
      valueGetter: (_, row) => row["idInspecaoPatrimonioItens"] as number,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onClick={() => {
                onActionLimpar(params.value);
              }}>
              <DynamicIcon nameIcon="CleaningServices" size={25} className="text-[#f8cb00]" />
            </IconButton>
          </div>
        );
      },
    },
  ];
};
